import SDKConfigurationModel from "../../../Configurator/Models/SDKConfiguraitonModel";
import { ErrorCodes } from "../../../Exception/ErrorCodes";
import { ErrorStatuses } from "../../../Exception/ErrorStatuses";
import { ErrorMessages } from "../../../Global/Messages/Messages";
import BaseValidator from "../../../Global/Validator/BaseValidator";
import MiniGamesFilters from "../Models/Filters/MiniGamesFilters";

export default class MiniGamesValidator extends BaseValidator {
  readonly entityTypes = ["competition", "team", "player"];

  constructor(config: SDKConfigurationModel) {
    super(config.errorHandlingMode);
  }

  public validateFilters = (filters: MiniGamesFilters) => {
    if (!filters.entityIds && !filters.entityType) {
      return;
    }

    if (filters.entityIds && !filters.entityType) {
      this.throwException(
        ErrorCodes.BAD_METHOD_CALL,
        ErrorStatuses.INVALID_FILTERS,
        ErrorMessages.FILTER_COMBINATION_ERROR
      );
    }

    if (!filters.entityIds && filters.entityType) {
      this.throwException(
        ErrorCodes.BAD_METHOD_CALL,
        ErrorStatuses.INVALID_FILTERS,
        ErrorMessages.FILTER_COMBINATION_ERROR
      );
    }

    if (!this.entityTypes.includes(filters.entityType)) {
      this.throwException(
        ErrorCodes.BAD_METHOD_CALL,
        ErrorStatuses.INVALID_FILTERS,
        ErrorMessages.INVALID_ENTITY_TYPE
      );
    }
  };
}
